const getUserTypeKey = (userData, isDirectLogin, isisImpersonating) => {
  let userKey;
  if (userData.isStudent) {
    userKey = 's';
  } else if (userData.isTeacher) {
    userKey = 't';
  } else if (userData.isAdmin) {
    userKey = 'a';
  } else if (userData.isCoordinator) {
    userKey = 'c';
  }

  if (isDirectLogin) {
    userKey += 'd';
  }

  if (isisImpersonating) {
    userKey += 'i';
  }

  return userKey;
};

/**
 * Creates key for video provider progress tracking
 * @param {object} config
 * @returns {string} environment-userType[0]-importId|userId
 * */
const createProgressTrackingKey = (config, isImpersonating) => {
  const { userData } = config;
  const { me } = userData;
  const { ssoLogin } = me;

  const isDirectLogin = ssoLogin === 'Not SSO';
  const { ENV } = process.env;
  let keys = [];
  const envKey = ENV === 'prod' ? '' : ENV;
  if (envKey) {
    keys.push(envKey);
  }
  const userKey = getUserTypeKey(userData, isDirectLogin, isImpersonating);
  if (userKey) {
    keys.push(userKey);
  }

  return keys.join('-');
};

export default createProgressTrackingKey;
